import { getSupabase } from '@/systems/SupabaseClient';

/**
 * ParentService — leitura do perfil do responsável logado.
 *
 * Hoje serve só pra checar o flag is_admin (CLAUDE.md §15: admin é
 * concedido manualmente via Table Editor do Supabase). Pode crescer
 * pra setProfile etc. quando precisarmos.
 *
 * RLS já restringe `parents` a `auth.uid() = id`, então não precisamos
 * filtrar manualmente.
 */

export type ParentResult<T> = { ok: true; value: T } | { ok: false; error: string };

export async function isCurrentUserAdmin(): Promise<boolean> {
  const { data, error } = await getSupabase().from('parents').select('is_admin').single();
  if (error || !data) return false;
  return Boolean((data as { is_admin: boolean }).is_admin);
}
